import * as t from './actionTypes';
import { SchedMsgResponse, DeleteMessagesRequest } from './types';

export const fetchScheduledMessagesRequest = () => ({
  type: t.FETCH_SCHEDULED_MESSAGES_REQUEST,
});

export const fetchScheduledMessagesError = (error: string) => ({
  type: t.FETCH_SCHEDULED_MESSAGES_ERROR,
  error,
});

export const fetchScheduledMessagesResponse = (payload: SchedMsgResponse) => ({
  type: t.FETCH_SCHEDULED_MESSAGES_RESPONSE,
  payload,
});

export const deleteScheduledMessagesRequest = (data: DeleteMessagesRequest) => ({
  type: t.DELETE_SCHEDULED_MESSAGES_REQUEST,
  payload: {
    messageMedium: data.messageMedium,
    ids: data.ids,
  },
});

export const deleteScheduledMessagesError = (error: string) => ({
  type: t.DELETE_SCHEDULED_MESSAGES_ERROR,
  error,
});

export const deleteScheduledMessagesResponse = (data: DeleteMessagesRequest) => ({
  type: t.DELETE_SCHEDULED_MESSAGES_RESPONSE,
  payload: {
    messageMedium: data.messageMedium,
    ids: data.ids,
  },
});

export const deleteAllScheduledMessagesRequest = (data: DeleteMessagesRequest) => ({
  type: t.DELETE_ALL_SCHEDULED_MESSAGES_REQUEST,
  payload: {
    messageMedium: data.messageMedium,
  },
});

export const deleteAllScheduledMessagesError = (error: string) => ({
  type: t.DELETE_ALL_SCHEDULED_MESSAGES_ERROR,
  error,
});

export const deleteAllScheduledMessagesResponse = (data: DeleteMessagesRequest) => ({
  type: t.DELETE_ALL_SCHEDULED_MESSAGES_RESPONSE,
  payload: {
    messageMedium: data.messageMedium,
  },
});
